import React from 'react';
import cx from 'classnames';
import { StyledTitle } from './styles';
import { getFontSize, getTitleTag } from './utils';
export const Title = (props) => {
    const tag = getTitleTag(props) || 'h1';
    return (React.createElement(StyledTitle, { className: cx('title', props.className), as: tag, style: props.style, fontSize: getFontSize(tag), "data-role": "title", id: props.id, type: props.type }, props.children));
};
